import { render, staticRenderFns } from "./privacy.component.vue?vue&type=template&id=248f3241&scoped=true&"
import script from "./privacy.component.ts?vue&type=script&lang=ts&"
export * from "./privacy.component.ts?vue&type=script&lang=ts&"
import style0 from "./privacy.component.scss?vue&type=style&index=0&id=248f3241&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f3241",
  null
  
)

export default component.exports